exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html[data-v-487de6c2]{background-color:#f8f7f6}", ""]);

